/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessinformationupdated2Inputs */

const en_businessinformationupdated2 = /** @type {(inputs: Businessinformationupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business information updated`)
};

const de_businessinformationupdated2 = /** @type {(inputs: Businessinformationupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschäftsinformationen aktualisiert`)
};

/**
* | output |
* | --- |
* | "Business information updated" |
*
* @param {Businessinformationupdated2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessinformationupdated2 = /** @type {((inputs?: Businessinformationupdated2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessinformationupdated2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessinformationupdated2(inputs)
	return de_businessinformationupdated2(inputs)
});
export { businessinformationupdated2 as "businessInformationUpdated" }